import { render } from "./AanmeldenVoorwaarden.vue?vue&type=template&id=c6f18372"
import script from "./AanmeldenVoorwaarden.vue?vue&type=script&lang=js"
export * from "./AanmeldenVoorwaarden.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__